// import React, { useEffect } from 'react';

import { useCustomTranslation } from '../../../../hooks/custom-translation';
import { Body, H3, H5 } from '../../../../styles/fonts';

import {
  ColumnBar,
  Content01,
  Data,
  // Data011,
  Data021,
  Row01,
  Row02,
} from './styles';

interface SocioDemographicTabProps {
  socioDemographic: {
    records: number;
    regularRfbPercentage: number;
    deathPercentage: number;
    higherIncome: {
      description: string;
      quantity: number;
      percentage: number;
    };
    generalData: {
      participationInCompaniesPercentage: number;
      higherFinancialRisk: {
        description: string;
        quantity: number;
        percentage: number;
      };
      higherEducation: {
        description: string;
        quantity: number;
        percentage: number;
      };
      higherMaritalStatus: {
        description: string;
        quantity: number;
        percentage: number;
      };
    };
    ageGroups: {
      description: string;
      quantity: number;
      percentage: number;
    }[];
    ageGroupsByGender: {
      description: string;
      masculino: number;
      feminino: number;
    }[];
    companyParticipations: {
      description: string;
      quantity: number;
      percentage: number;
    }[];
  };
}

const SocioDemographicTab = ({
  socioDemographic,
}: SocioDemographicTabProps) => {
  const { tModalDescriptiveAnalysis } = useCustomTranslation(
    'modalDescriptiveAnalysis',
  );

  const AgeGroupBar = () => {
    const data = [...socioDemographic.ageGroups].sort((a, b) => {
      return a.percentage - b.percentage; // Ordena do menor para o maior
    });

    const config = {
      data,
      xField: 'description',
      yField: 'percentage',
      barWidthRatio: 0.7,
      height: 300,
      width: 250,
      animation: false,
      meta: {
        age: {
          alias: 'idade',
        },
        percentage: {
          alias: 'porcentagem',
        },
      },
    };
    return <ColumnBar {...config} />;
  };

  // const GeneralDataBar = () => {
  //   const data = [
  //     {
  //       type: socioDemographic?.generalData?.higherEducation?.description,
  //       number: socioDemographic?.generalData?.higherEducation?.percentage,
  //     },
  //     {
  //       type: tModalDescriptiveAnalysis('participation_in_companies'),
  //       number:
  //         socioDemographic?.generalData?.participationInCompaniesPercentage,
  //     },
  //   ];

  //   const config = {
  //     data,
  //     xField: 'number',
  //     yField: 'type',
  //     barWidthRatio: 0.4,
  //     height: 300,
  //     width: 250,
  //     animation: false,
  //     meta: {
  //       type: {
  //         alias: '',
  //       },
  //       number: {
  //         alias: 'porcentagem',
  //       },
  //     },
  //   };

  //   useEffect(() => {
  //     if (socioDemographic?.generalData?.higherMaritalStatus?.description) {
  //       data.push({
  //         type: socioDemographic?.generalData?.higherMaritalStatus?.description,
  //         number:
  //           socioDemographic?.generalData?.higherMaritalStatus?.percentage,
  //       });
  //     }
  //   }, []);

  //   return <LineBar {...config} />;
  // };

  return (
    <>
      <Content01>
        {socioDemographic && (
          <Row01>
            <Data>
              <H3>{socioDemographic.records.toLocaleString('pt-BR')}</H3>
              <Body weight="regular">
                {tModalDescriptiveAnalysis('records')}
              </Body>
            </Data>
            {socioDemographic.higherIncome && (
              <Data>
                <H3 weight="medium">
                  {socioDemographic.higherIncome.percentage}
                  {tModalDescriptiveAnalysis('%')}
                </H3>
                <Body>{socioDemographic.higherIncome.description}</Body>
              </Data>
            )}
            <Data>
              <H3 weight="medium">
                {socioDemographic.regularRfbPercentage}
                {tModalDescriptiveAnalysis('%')}
              </H3>
              <Body>{tModalDescriptiveAnalysis('regular_rfb')}</Body>
            </Data>
            <Data>
              <H3 weight="medium">
                {socioDemographic.deathPercentage}
                {tModalDescriptiveAnalysis('%')}
              </H3>
              <Body>{tModalDescriptiveAnalysis('death')}</Body>
            </Data>
          </Row01>
        )}
        <Row02>
          {/* <Data011>
            <H5 weight="medium">{tModalDescriptiveAnalysis('general_data')}</H5>
            <GeneralDataBar />
          </Data011> */}
          <Data021>
            <H5 weight="medium">{tModalDescriptiveAnalysis('age_group')}</H5>
            <AgeGroupBar />
          </Data021>
        </Row02>
      </Content01>
    </>
  );
};

export default SocioDemographicTab;
